import { Element, useEditor } from "@craftjs/core";
import Tooltip from "@mui/material/Tooltip";
import { Menu, Repeat } from "lucide-react";
import SectionBlock from "@/components/editor/blocks/section-block/SectionBlock";
import ContainerBlock from "@/components/editor/blocks/ContainerBlock";
import RepeatBlock from "@/components/editor/blocks/RepeatBlock";
import TextBlock from "@/components/editor/blocks/TextBlock";
import ImageBlock from "@/components/editor/blocks/ImageBlock";
import DishBlock from "@/components/editor/blocks/DishBlock";
import VerticalSpacerBlock from "@/components/editor/blocks/VerticalSpacerBlock";
import SocialMediaBlock from "@/components/editor/blocks/SocialMediaBlock";
import ButtonBlock from "@/components/editor/blocks/ButtonBlock";
import MapBlock from "@/components/editor/blocks/MapBlock";
import FaqsBlock from "@/components/editor/blocks/FaqsBlock";
import MenuBlock from "@/components/editor/blocks/MenuBlock";
import CartBlock from "../../blocks/CartBlock";
import RegionBlock from "../../blocks/RegionBlock";
import CarouselBlock from "../../blocks/CarouselBlock";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  Directions02Icon,
  AlignSelectionIcon,
  VerticalResizeIcon,
  Image02Icon,
  CarouselHorizontal02Icon,
  ThumbsUpIcon,
  CookBookIcon,
  Location06Icon,
  MessageQuestionIcon,
  ShoppingCart01Icon,
  SearchAreaIcon,
  TextFontIcon,
  CursorPointer01Icon,
  LayerIcon,
} from "@hugeicons/core-free-icons";
import { Divider } from "@mui/material";
import "./styles.scss";
import ElementBlock from "../../blocks/ElementBlock";

const Toolbox = () => {
  const {
    connectors: { create },
  } = useEditor((state) => ({
    enabled: state.options.enabled,
  }));

  return (
    <div className="editor__toolbox">
      {/* <Scrollbars autoHide> */}
      <div className="tool" ref={(ref: any) => create(ref, <Element canvas is={SectionBlock} />)}>
        <Tooltip title="Sección" placement="left" arrow>
          <HugeiconsIcon icon={Directions02Icon} className="tool__icon" />
        </Tooltip>
      </div>
      <div className="tool" ref={(ref: any) => create(ref, <Element canvas is={ContainerBlock} />)}>
        <Tooltip title="Contenedor" placement="left" arrow>
          <HugeiconsIcon icon={AlignSelectionIcon} className="tool__icon" />
        </Tooltip>
      </div>
      <div className="tool" ref={(ref: any) => create(ref, <TextBlock />)}>
        <Tooltip title="Texto" placement="left">
          <HugeiconsIcon icon={TextFontIcon} className="tool__icon" />
        </Tooltip>
      </div>
      <div className="tool" ref={(ref: any) => create(ref, <ImageBlock />)}>
        <Tooltip title="Imagen" placement="left">
          <HugeiconsIcon icon={Image02Icon} className="tool__icon" />
        </Tooltip>
      </div>
      <Divider color="white" />
      <div className="tool" ref={(ref: any) => create(ref, <Element canvas is={RepeatBlock} />)}>
        <Tooltip title="Repetidor" placement="left" arrow>
          <Repeat className="tool__icon" />
        </Tooltip>
      </div>
      <div className="tool" ref={(ref: any) => create(ref, <VerticalSpacerBlock />)}>
        <Tooltip title="Espaciado Vertical" placement="left">
          <HugeiconsIcon icon={VerticalResizeIcon} className="tool__icon" />
        </Tooltip>
      </div>
      <div className="tool" ref={(ref: any) => create(ref, <ButtonBlock />)}>
        <Tooltip title="Botón" placement="left">
          <HugeiconsIcon icon={CursorPointer01Icon} className="tool__icon" />
        </Tooltip>
      </div>
      <div className="tool" ref={(ref: any) => create(ref, <CarouselBlock />)}>
        <Tooltip title="Carrusel" placement="left">
          <HugeiconsIcon icon={CarouselHorizontal02Icon} className="tool__icon" />
        </Tooltip>
      </div>
      <div className="tool" ref={(ref: any) => create(ref, <SocialMediaBlock />)}>
        <Tooltip title="Redes Sociales" placement="left">
          <HugeiconsIcon icon={ThumbsUpIcon} className="tool__icon" />
        </Tooltip>
      </div>
      <div className="tool" ref={(ref: any) => create(ref, <DishBlock />)}>
        <Tooltip title="Plato" placement="left">
          <HugeiconsIcon icon={CookBookIcon} className="tool__icon" />
        </Tooltip>
      </div>
      <div className="tool" ref={(ref: any) => create(ref, <MapBlock />)}>
        <Tooltip title="Mapa" placement="left">
          <HugeiconsIcon icon={Location06Icon} className="tool__icon" />
        </Tooltip>
      </div>
      <div className="tool" ref={(ref: any) => create(ref, <FaqsBlock />)}>
        <Tooltip title="FAQs" placement="left">
          <HugeiconsIcon icon={MessageQuestionIcon} className="tool__icon" />
        </Tooltip>
      </div>
      <div className="tool" ref={(ref: any) => create(ref, <MenuBlock />)}>
        <Tooltip title="Menu" placement="left">
          <Menu className="tool__icon" />
        </Tooltip>
      </div>
      <div className="tool" ref={(ref: any) => create(ref, <CartBlock />)}>
        <Tooltip title="Cart" placement="left">
          <HugeiconsIcon icon={ShoppingCart01Icon} className="tool__icon" />
        </Tooltip>
      </div>
      <div className="tool" ref={(ref: any) => create(ref, <RegionBlock />)}>
        <Tooltip title="Region" placement="left">
          <HugeiconsIcon icon={SearchAreaIcon} className="tool__icon" />
        </Tooltip>
      </div>
      <div className="tool" ref={(ref: any) => create(ref, <ElementBlock />)}>
        <Tooltip title="Elementos" placement="left">
          <HugeiconsIcon icon={LayerIcon} className="tool__icon" />
        </Tooltip>
      </div>
      {/* </Scrollbars> */}
    </div>
  );
};

export default Toolbox;
